import { getMidnightInTimezone } from "./rateCard";

/**
 * The "YYYY-MM" billing month that `at` falls in, in `timeZone`, moved back `monthsBack` months.
 * A tenant's month is THEIR calendar month, not UTC's: 00:30 IST on the 1st is already the new one.
 */
export function billingMonth(at: Date, timeZone: string, monthsBack = 0): string {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit" }).formatToParts(at);
  const year = Number(parts.find((p) => p.type === "year")?.value);
  const month = Number(parts.find((p) => p.type === "month")?.value);
  const index = year * 12 + (month - 1) - monthsBack;
  return `${Math.floor(index / 12)}-${String((index % 12) + 1).padStart(2, "0")}`;
}

/** Whether `value` is a "YYYY-MM" month, e.g. what an `<input type="month">` holds when filled. */
export function isBillingMonth(value: string): boolean {
  return /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
}

/** [start, end) of a "YYYY-MM" month in `timeZone`. `end` is the instant the next month begins. */
export function monthBounds(month: string, timeZone: string): { start: Date; end: Date } {
  const [year, monthNumber] = month.split("-").map(Number);
  const next = monthNumber === 12 ? `${year + 1}-01` : `${year}-${String(monthNumber + 1).padStart(2, "0")}`;
  return {
    start: new Date(getMidnightInTimezone(`${month}-01`, timeZone)),
    end: new Date(getMidnightInTimezone(`${next}-01`, timeZone)),
  };
}
